module.exports = __webpack_public_path__ + "img/the-qi_thumbnail.3fc3193b.png";